import {Badge} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {DimensionKind, PricingSource, ProductStatus} from '../types';

const STATUS_DISPLAY: Record<ProductStatus, { color: string, label: string }> = {
    DRAFT: {color: 'gray', label: 'Draft'},
};

export const ProductStatusBadge = ({status}: { status?: ProductStatus | null }) => {
    const display = status ? STATUS_DISPLAY[status] : undefined;

    if (!display) {
        return <Badge color='dark' variant='outline'>{status ?? '—'}</Badge>;
    }

    return <Badge color={display.color} variant='light'>{I18n.get(display.label)}</Badge>;
};

const PRICING_SOURCE_DISPLAY: Record<PricingSource, { color: string, label: string }> = {
    NATIVE: {color: 'teal', label: 'Native'},
    LINKED: {color: 'indigo', label: 'Linked to billing'},
};

export const PricingSourceBadge = ({source}: { source?: PricingSource | null }) => {
    const display = source ? PRICING_SOURCE_DISPLAY[source] : undefined;

    if (!display) {
        return <Badge color='dark' variant='outline'>{source ?? '—'}</Badge>;
    }

    return <Badge color={display.color} variant='light'>{I18n.get(display.label)}</Badge>;
};

const KIND_DISPLAY: Record<DimensionKind, { color: string, label: string }> = {
    FLAT: {color: 'blue', label: 'Flat'},
    CONTRACT: {color: 'grape', label: 'Contract'},
    USAGE: {color: 'orange', label: 'Usage'},
};

export const DimensionKindBadge = ({kind}: { kind?: DimensionKind | null }) => {
    const display = kind ? KIND_DISPLAY[kind] : undefined;

    if (!display) {
        return <Badge color='dark' variant='outline'>{kind ?? '—'}</Badge>;
    }

    return <Badge color={display.color} variant='light'>{I18n.get(display.label)}</Badge>;
};
